import log from '../../../util/logger';
import { getValue } from '../../../util/object';
import { inArray, extend } from '../../../util/jquery';

export function marketsIdServiceTransform(data, params) {
    const ret = [];
    const resultsMap = new Map();

    const results = data.Records || [];
    results.forEach(d => {
        resultsMap.set(d.QueryKey, d);
    });
    const invalidTicker = (data.resultStatus && data.resultStatus.failed) || {};
    const noPermitArray = invalidTicker['10001'] || [];
    const inValidArray = invalidTicker['10002'] || [];

    params.symbol.split(',').forEach(symbol => {
        if (resultsMap.has(symbol)) {
            ret.push(getSecurityJSON(resultsMap.get(symbol)));
        } else if (inArray(noPermitArray, symbol) > -1) {
            ret.push({
                queryKey: symbol,
                _noPermit: true
            });
        } else if (inArray(inValidArray, symbol) > -1) {
            ret.push({
                queryKey: symbol,
                _noData: true
            });
        }
    });

    if (Object.keys(invalidTicker).length) {
        log.error(
            'morningstar.markets.marketdata.idService',
            'can not get data from remote',
            {
                symbols: invalidTicker
            }
        );
    }

    return ret;
}

export function marketsImportFileTransform(data) {
    return (data.data || []).map(d => {
        return extend({}, getSecurityJSON(d), {
            isRequestIdService: true
        });
    });
}

function getSecurityJSON(d) {
    return {
        mstarType: getValue(d, 'Type,type'),
        mstarSymbol: getValue(d, 'Ticker,msSymbol'),
        rtType: getValue(d, 'SecurityType,securityType'),
        rtExchangeId: getValue(d, 'ListingMarket,listingMarket'),
        rtMarketDataExchangeID: getValue(
            d,
            'MarketDataExchangeID,marketDataExchangeID'
        ),
        rtSymbol: getValue(d, 'Symbol,symbol'),
        clientSymbol: getValue(d, 'ClientTicker,clientTicker'),
        performanceId: getValue(d, 'PID,performanceId'),
        securityId: getValue(d, 'SID,secId'),
        companyId: getCompanyId(d),
        categoryId: getValue(d, 'OF012'),
        categoryName: getPerformanceTickerId(d, 'CA680'),
        relativeRiskBenchmarkId: getPerformanceTickerId(d, 'OS384'),
        morningstarIndexName: getValue(d, 'MstarIndex'),
        morningstarIndexId: getPerformanceTickerId(d, 'MIndexId'),
        primaryProspectusBenchmarkName: getValue(
            d,
            'PrimaryProspectusBenchmark'
        ),
        primaryProspectusBenchmarkId: getPerformanceTickerId(
            d,
            'PrimaryProspectusBenchmarkId'
        ),
        name: getValue(d, 'OS01W,Name,companyName'),
        currency: getValue(d, 'TransactionMoney,Currency,currency'),
        queryKey: getValue(d, 'QueryKey,queryKey'),
        domicile: getValue(d, 'DomicileCountry,domicileCountry'),
        MICCode: getValue(d, 'AC031,micCode'),
        Exch: getValue(d, 'Exch,shortName'),
        CUSIP: getValue(d, 'CUSIP'),
        ISIN: getValue(d, 'ISIN'),
        region: getValue(d, 'Region,region'),
        strikePrice: getValue(d, 'StrikePrice'),
        IPODate: getValue(d, 'IPODate'),
        baseCurrency: getValue(d, 'OS05M')
    };
}

function getPerformanceTickerId(obj, fields) {
    let value = getValue(obj, fields);
    if (value === 'N/A') {
        value = '';
    }
    return value;
}

function getCompanyId(d) {
    let companyId = d.CFID;
    const mstarType = d.Type;
    switch (mstarType) {
        case 'FE':
        case 'FC':
        case 'FO':
            companyId = d.DAS02;
            break;
    }
    return companyId || '';
}
